import { Button } from "react-bootstrap";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import { useDispatch } from "react-redux";
import { BsEye, BsGearFill } from "react-icons/bs";
import HelperService from "../../../utility/HelperService";
import { connect, useSelector } from "react-redux";
import { projectEditPageRequest, projectRequest, projectDeleteConfirm, projectDeleteDecline, projectDeleteRequest } from "../ProjectAction";
import { ProjectInterface, ProjectState } from "../ProjectTypes";
import { permissionsInterface, reduxInitialState } from "../../onBoarding/onBoardingTypes";
import { navigationRequest } from "../../../Navigation/NavigationRedux/NavigationRedux";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import routePaths from "../../../Navigation/routePaths";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import { useEffect, useState } from "react";
import ProjectDasboard from "./ProjectDasboard";

const headers: GridHeader[] = [
  {
    title: "Date ",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "created_at",
  },
  {
    title: "Project name",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "project_name",
  },
  {
    title: "Address",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "address",
  },
  {
    title: "Unit Count",
    class: "text-left",
  },
  {
    title: "Status",
    class: "text-left",
    // isSorting: true,
    // isAsc: true,
    // sortingKey: "status	",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

interface propData {
  getProjects: (params: any) => void;
  onNavigate: (path: string) => void;
  editProject: (data: ProjectInterface) => void;
  onDeleteProject: () => void;
}

const Projects = (props: propData) => {
  const dispatch = useDispatch();
  const projectData: ProjectState = useSelector((state: reduxInitialState) => state.ProjectReducer);
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [projectUuid, setProjectUuid] = useState<string>("");
  const [openProjectDashboard, setOpenProjectDashboard] = useState<boolean>(false);
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const [pressedKeys, setPressedKeys] = useState(new Set());

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
    }
  }, [token])

  const getProjectList = async (page: number, keyword?: string, startDate?: Date, endDate?: Date, order_by?: string, sort_by?: string) => {
    !projectData.loading &&
      props.getProjects({ page: page, keyword: keyword, fromDate: startDate, toDate: endDate, sort_by: order_by ?? "desc", order_by: sort_by ?? "created_at" });
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getProjectList(offset, "", null as any, null as any, isAscending ? "asc" : "desc", key);
  };

  const getFormatedProjectRow = (list: ProjectInterface[]) => {
    let rows: GridRow[] = [];
    for (var i in list) {
      let isSold = list[i].sold_unit === list[i].project_unit ? false : true;
      let columns: GridColumn[] = [];
      columns.push({
        value:
          list[i].created_at &&
          HelperService.getFormatedDate(list[i].created_at),
      });
      columns.push({
        value: getProjectName(list[i]),
      });
      columns.push({ value: list[i].address ? list[i].address : "N/A" });
      columns.push({
        value:
          (list[i].sold_unit ? list[i].sold_unit : "0") +
          "/" +
          (list[i].project_unit ? list[i].project_unit : "0"),
      });
      columns.push({ value: statusList(isSold) });
      columns.push({ value: ViewDetail(list[i], isSold) });
      rows.push({ data: columns });
    }
    return rows;
  };

  const statusList = (status: boolean) => {
    if (status) {
      return (
        <span className="badge bg-success-subtle text-success">Available</span>
      );
    } else {
      return <span className="badge bg-danger-subtle text-danger">Sold</span>;
    }
  };

  const ViewDetail = (data: ProjectInterface, isSold: boolean) => {
    return (
      <span className="action-btns">
        <button
          onClick={() => {
            props.onNavigate(routePaths.PROJECT_UNIT_LIST.path + data.uuid);
          }}
          className="cursor-pointer btn-pass btn"
        >
          <span className="badge text-warning">Unit</span>{" "}
        </button>
        <button onClick={() => props.onNavigate(routePaths.PROJECT_STATUS_VIEW.path + data.uuid)} className="cursor-pointer btn-eye btn"> <BsEye /> </button>
        {permissions && permissions.can_update && <button onClick={() => props.onNavigate(routePaths.MARK_UNIT.path + data.uuid)} className="cursor-pointer btn-eye btn"> <BsGearFill /> </button>}
        {
          isSold && (
            <>
              {permissions && permissions.can_update && <button
                onMouseDown={() => props.editProject(data)}
                onClick={() => {
                  props.onNavigate(routePaths.UPDATE_PROJECT.path);
                }}
                className="cursor-pointer  btn-edit btn"
              >
                {" "}
                <Pencil />{" "}
              </button>}
              {permissions && permissions.can_delete && <button
                onClick={() => dispatch(projectDeleteConfirm(data))}
                className="cursor-pointer btn btn-delete"
              >
                {" "}
                <Trash />{" "}
              </button>}
            </>
          )
        }
      </span >
    );
  };

  const getProjectName = (data: ProjectInterface) => {
    return (<a href="javascript:void(0)" onClick={() => { setProjectUuid(data.uuid); setOpenProjectDashboard(true); }}>{data.project_name} </a>);
  };

  const handleKeyUp = (e: any) => {
    const key = e.key.toLowerCase();
    // Check for ctrl+p+t
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
      setShowHiddenFields(true);
    }

    // Remove the key from the set
    setPressedKeys((prev: any) => {
      const updated = new Set(prev);
      updated.delete(key);
      return updated;
    });
  };

  const handleKeyDown = (e: any) => {
    const key = e.key.toLowerCase();
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  return (
    <>
      <DeleteModal isShow={projectData.showDeleteModal} close={() => { dispatch(projectDeleteDecline()); }} onDelete={() => { props.onDeleteProject(); }} />
      <ProjectDasboard
        isShow={openProjectDashboard}
        isClose={() => {
          setOpenProjectDashboard(false);
          setProjectUuid("");
        }}
        project_uuid={projectUuid}
        is_session={showHiddenFields}
      />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Projects" backArrow={false} active={showHiddenFields} />
          {permissions && permissions.can_write &&
            <Button className="btn btn-brand-1 mb-3" onClick={() => { props.onNavigate(routePaths.ADD_NEW_PROJECT.path); }}>
              {" "}
              <Plus size={20} className="ms-1" /> Add Project
            </Button>}
        </div>
        <div className="table-card">
          {projectData && (
            <Grid
              rows={getFormatedProjectRow(projectData.projectList)}
              showSearch={true}
              headers={headers}
              showDateFilter={true}
              ShowLoader={projectData.loading}
              count={projectData.listCount}
              onPageChange={getProjectList}
              errorMessage={"No Project Found"}
              onSort={onSortList}
            />
          )}
        </div>
      </div>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  getProjects: (params: any) => dispatch(projectRequest(params)),
  onNavigate: (path: string) => dispatch(navigationRequest(path)),
  editProject: (data: ProjectInterface) =>
    dispatch(projectEditPageRequest(data)),
  onDeleteProject: () => dispatch(projectDeleteRequest()),
});

export default connect(null, mapDispatchToProps)(Projects);
